// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GoTo$LiveRoom from "../../GoTo.bs.js";
import * as Config$LiveRoom from "../../../Config.bs.js";
import * as Css_Legacy_Core from "bs-css/src/Css_Legacy_Core.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as MomentTZ$LiveRoom from "../../bindings/MomentTZ.bs.js";
import * as SvgImages$LiveRoom from "../../assets/img/SvgImages.bs.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as OverviewModal$LiveRoom from "../../components/Modal/OverviewModal.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as Utils_Auction$LiveRoom from "../../Utils/Utils_Auction.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as CustomerSession$LiveRoom from "./CustomerSession.bs.js";
import * as Icons_Component$LiveRoom from "../../components/Icons_Component.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as Tooltip from "@sothebys/sterling/tooltip";
import * as Dropdown from "@sothebys/sterling/dropdown";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";
import * as AlternativeCurrency$LiveRoom from "../../stores/AlternativeCurrency.bs.js";
import * as ConditionsOfSaleModal$LiveRoom from "../../components/Modal/ConditionsOfSaleModal.bs.js";
import * as HeaderSessionIndicator$LiveRoom from "../../components/HeaderSessionIndicator.bs.js";
import * as AlternativeCurrencyModal$LiveRoom from "../../components/Modal/AlternativeCurrencyModal.bs.js";
import * as AuctionRoomSharedContacts$LiveRoom from "../../components/AuctionRoomSharedContacts.bs.js";
import * as ActionNeededPendingEnrollment$LiveRoom from "../../components/Modal/ActionNeededPendingEnrollment.bs.js";

function Header$LivePill(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.justifyContent("end_"),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.alertRed60_nohashtag)),
                        tl: {
                          hd: Css.height(Css.px(18)),
                          tl: {
                            hd: Css.width(Css.px(60)),
                            tl: {
                              hd: Css.borderRadius(Css.px(25)),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(SterlingTypography$LiveRoom.Label12Medium.make, {
                      className: Curry._1(Css.style, {
                            hd: Css.textAlign("center"),
                            tl: {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey10_nohashtag)),
                              tl: /* [] */0
                            }
                          }),
                      children: Curry._1(match.t, "Common_live")
                    })));
}

var LivePill = {
  make: Header$LivePill
};

function Header$AuctionTitle(props) {
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "auctionHeaderTitle"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                    className: Curry._1(Css.style, {
                          hd: Css.unsafe("WebkitLineClamp", "calc(2)"),
                          tl: {
                            hd: Css.unsafe("display", "-webkit-box"),
                            tl: {
                              hd: Css.unsafe("WebkitBoxOrient", "vertical"),
                              tl: {
                                hd: Css.overflow(Css.hidden),
                                tl: {
                                  hd: Css.wordWrap("breakWord"),
                                  tl: {
                                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }),
                    children: props.auctionName
                  })
            });
}

var AuctionTitle = {
  make: Header$AuctionTitle
};

function Header$AuctionDate(props) {
  var maybeDate = Belt_Option.flatMap(props.date, Js_json.decodeString);
  var locationName = Belt_Option.mapWithDefault(props.location, "", (function (x) {
          return x.displayLocation.name;
        }));
  var match = maybeDate !== undefined ? [
      MomentTZ$LiveRoom.momentFormat(maybeDate, "D MMMM"),
      MomentTZ$LiveRoom.momentFormat(maybeDate, "HH:mm z")
    ] : [
      "",
      ""
    ];
  var text = locationName + "\n" + match[0] + " " + match[1];
  return React.createElement(SterlingTypography$LiveRoom.Paragraph12Regular.make, {
              className: Curry._1(Css.style, {
                    hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey80_nohashtag)),
                    tl: {
                      hd: Css.whiteSpace("pre"),
                      tl: /* [] */0
                    }
                  }),
              children: text
            });
}

var AuctionDate = {
  make: Header$AuctionDate
};

function Header$UserRegistration$Label(props) {
  return React.createElement(React.Fragment, undefined, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "userRegistration"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                              tl: {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.alignItems("center"),
                                  tl: {
                                    hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                          hd: Css.display("none"),
                                          tl: /* [] */0
                                        }),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }),
                        children: props.text
                      })
                }));
}

var Label = {
  make: Header$UserRegistration$Label
};

function Header$UserRegistration(props) {
  var enrollmentSessionStatus = props.enrollmentSessionStatus;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(React.Fragment, undefined, typeof enrollmentSessionStatus === "number" ? (
                enrollmentSessionStatus !== 0 ? (
                    enrollmentSessionStatus >= 3 ? React.createElement("div", {
                            className: Curry._1(Css.style, {
                                  hd: Css.display("flex"),
                                  tl: {
                                    hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.alertYellow20_nohashtag)),
                                    tl: {
                                      hd: Css.borderRadius(Css.px(4)),
                                      tl: {
                                        hd: Css.maxWidth(Css.px(208)),
                                        tl: {
                                          hd: Css.padding(Css.px(4)),
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                })
                          }, React.createElement("div", {
                                className: Curry._1(Css.style, {
                                      hd: Css.display("flex"),
                                      tl: {
                                        hd: Css.margin2("auto", Css.px(0)),
                                        tl: {
                                          hd: Css.marginRight(Css.px(8)),
                                          tl: /* [] */0
                                        }
                                      }
                                    })
                              }, React.createElement(Icons_Component$LiveRoom.AttentionYellow.make, {})), React.createElement("div", {
                                className: Curry._1(Css.style, {
                                      hd: Css.display("block"),
                                      tl: {
                                        hd: Css.margin2("auto", Css.px(0)),
                                        tl: /* [] */0
                                      }
                                    })
                              }, React.createElement(PropSpread$LiveRoom.make, {
                                    data: {
                                      hd: {
                                        TAG: /* TestId */1,
                                        _0: "incompleteRegistrationHeaders"
                                      },
                                      tl: /* [] */0
                                    },
                                    children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                                          children: Curry._1(t, "LeftContainerMessage_registrationIncomplete")
                                        })
                                  }), React.createElement(SterlingTypography$LiveRoom.ButtonLink12Regular.make, {
                                    onClick: props.showIncompleteRegistrationModal,
                                    children: Curry._1(t, "Common_learnMore")
                                  }))) : React.createElement(Header$UserRegistration$Label, {
                            text: Curry._1(t, "LeftContainer_youAreNotRegisteredToBid")
                          })
                  ) : React.createElement(Header$UserRegistration$Label, {
                        text: Curry._1(t, "LeftContainer_youAreNotLoggedIn")
                      })
              ) : React.createElement(Header$UserRegistration$Label, {
                    text: Curry._2(match.t2, "LeftContainer_welcome", {
                          paddleId: enrollmentSessionStatus._0
                        })
                  }));
}

var UserRegistration = {
  Label: Label,
  make: Header$UserRegistration
};

var imageMargin = Curry._1(Css.style, {
      hd: Css.marginRight(Css.px(8)),
      tl: /* [] */0
    });

function Header$MobileMenuDropdown$MenuAction(props) {
  var icon = props.icon;
  var textColor = props.textColor;
  var textColor$1 = textColor !== undefined ? textColor : Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag);
  var icon$1 = icon !== undefined ? Caml_option.valFromOption(icon) : null;
  return React.createElement(Dropdown.Dropdown.Action, {
              id: props.id,
              onClick: props.onClick,
              children: null
            }, icon$1, React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                  className: Curry._1(Css.style, {
                        hd: Css.color(textColor$1),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.margin2("auto", Css.px(0)),
                            tl: /* [] */0
                          }
                        }
                      }),
                  children: props.text
                }));
}

var MenuAction = {
  make: Header$MobileMenuDropdown$MenuAction
};

function Header$MobileMenuDropdown$UserRegistrationMenuItem(props) {
  var saleNumber = props.saleNumber;
  var showSelectAccount = props.showSelectAccount;
  var setModalToShow = props.setModalToShow;
  var enrollmentSessionStatus = props.enrollmentSessionStatus;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  var userIcon = React.createElement(SterlingIcons$LiveRoom.Collection.User24.make, {
        className: imageMargin
      });
  if (typeof enrollmentSessionStatus === "number") {
    if (enrollmentSessionStatus !== 2) {
      if (enrollmentSessionStatus >= 3) {
        return React.createElement(Header$MobileMenuDropdown$MenuAction, {
                    id: "MenuOptionUserInfo",
                    onClick: (function (param) {
                        Curry._1(setModalToShow, (function (param) {
                                return /* ActionNeededToBid */3;
                              }));
                      }),
                    text: Curry._1(t, "LeftContainerMessage_registrationIncomplete"),
                    icon: Caml_option.some(React.createElement(SterlingIcons$LiveRoom.Collection.Attention24.make, {
                              className: Curry._1(Css.style, {
                                    hd: Css.marginRight(Css.px(8)),
                                    tl: {
                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.alertOrange60_nohashtag)),
                                      tl: /* [] */0
                                    }
                                  })
                            }))
                  });
      } else {
        return React.createElement(Header$MobileMenuDropdown$MenuAction, {
                    id: "MenuOptionUserInfo",
                    onClick: (function (param) {
                        AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                              showVerifyAccount: true,
                              origin: /* PlaceBid */0,
                              saleNumber: saleNumber
                            }, {
                              showSelectAccount: true
                            }, Config$LiveRoom.values.transactionlUrl);
                      }),
                    text: Curry._1(t, "FeedButton_loginToPlaceABid"),
                    icon: Caml_option.some(userIcon)
                  });
      }
    } else {
      return React.createElement(Header$MobileMenuDropdown$MenuAction, {
                  id: "MenuOptionUserInfo",
                  onClick: (function (param) {
                      Curry._1(showSelectAccount, undefined);
                    }),
                  text: Curry._1(t, "RegisterToBid"),
                  icon: Caml_option.some(userIcon)
                });
    }
  } else {
    return React.createElement("div", {
                className: Curry._1(Css.style, {
                      hd: Css.marginLeft(Css.px(16)),
                      tl: {
                        hd: Css.display("flex"),
                        tl: /* [] */0
                      }
                    })
              }, userIcon, React.createElement(PropSpread$LiveRoom.make, {
                    data: {
                      hd: {
                        TAG: /* TestId */1,
                        _0: "userWelcomeHeader"
                      },
                      tl: /* [] */0
                    },
                    children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                          className: Curry._1(Css.style, {
                                hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                                tl: {
                                  hd: Css.display("flex"),
                                  tl: {
                                    hd: Css.margin2("auto", Css.px(0)),
                                    tl: /* [] */0
                                  }
                                }
                              }),
                          children: Curry._2(match.t2, "LeftContainer_welcome", {
                                paddleId: enrollmentSessionStatus._0
                              })
                        })
                  }));
  }
}

var UserRegistrationMenuItem = {
  make: Header$MobileMenuDropdown$UserRegistrationMenuItem
};

function Header$MobileMenuDropdown(props) {
  var setModalToShow = props.setModalToShow;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(Dropdown.Dropdown, {
              id: "MobileMenuDropdown",
              className: Curry._1(Css.style, {
                    hd: Css.visibility(props.showMobileLotList ? "hidden" : "visible"),
                    tl: {
                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                      tl: {
                        hd: Css.margin2("auto", Css.px(0)),
                        tl: {
                          hd: Css.zIndex(210),
                          tl: /* [] */0
                        }
                      }
                    }
                  }),
              alignment: "bottomLeft",
              buttonStyle: "tertiary",
              buttonSize: "regularIcon",
              children: React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.width(Css.px(280)),
                          tl: {
                            hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
                            tl: {
                              hd: Css.border(Css.px(1), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag)),
                              tl: {
                                hd: Css.boxShadow(Css_Legacy_Core.Shadow.box(Css.px(0), Css.px(0), Css.px(10), undefined, undefined, Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey30_nohashtag))),
                                tl: /* [] */0
                              }
                            }
                          }
                        })
                  }, React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.justifyContent("spaceBetween"),
                                tl: {
                                  hd: Css.margin(Css.px(16)),
                                  tl: /* [] */0
                                }
                              }
                            })
                      }, React.createElement(Header$AuctionDate, {
                            location: props.location,
                            date: props.date
                          }), props.isSessionLive ? React.createElement(Header$LivePill, {}) : null), React.createElement(Dropdown.Dropdown.Divider, {}), React.createElement(Header$MobileMenuDropdown$UserRegistrationMenuItem, {
                        enrollmentSessionStatus: props.enrollmentSessionStatus,
                        setModalToShow: setModalToShow,
                        showSelectAccount: props.showSelectAccount,
                        saleNumber: props.saleNumber
                      }), React.createElement(Header$MobileMenuDropdown$MenuAction, {
                        id: "MenuOptionCurrency",
                        onClick: (function (param) {
                            Curry._1(setModalToShow, (function (param) {
                                    return /* AlternativeCurrencyModal */4;
                                  }));
                          }),
                        text: Curry._1(t, "CurrencyConverter"),
                        icon: Caml_option.some(React.createElement(AlternativeCurrency$LiveRoom.CurrencyFlag.make, {
                                  baseCurrency: props.baseCurrency,
                                  imgHeight: 28,
                                  imgWidth: 28
                                }))
                      }), React.createElement(Header$MobileMenuDropdown$MenuAction, {
                        id: "MenuOptionOverView",
                        onClick: (function (param) {
                            Curry._1(setModalToShow, (function (param) {
                                    return /* OverviewModal */1;
                                  }));
                          }),
                        text: Curry._1(t, "Common_overView")
                      }), React.createElement(Header$MobileMenuDropdown$MenuAction, {
                        id: "MenuOptionCondition",
                        onClick: (function (param) {
                            Curry._1(setModalToShow, (function (param) {
                                    return /* ConditionsOfSaleModal */2;
                                  }));
                          }),
                        text: Curry._1(t, "Common_conditionsOfBusiness")
                      }))
            });
}

var MobileMenuDropdown = {
  imageMargin: imageMargin,
  MenuAction: MenuAction,
  UserRegistrationMenuItem: UserRegistrationMenuItem,
  make: Header$MobileMenuDropdown
};

function Header$DesktopAndMobileView(props) {
  var showMobileLotList = props.showMobileLotList;
  var toggleMobileLotListClick = props.toggleMobileLotListClick;
  var fragment = props.fragment;
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement(PropSpread$LiveRoom.make, {
                  aria: {
                    hd: {
                      TAG: /* Label */3,
                      _0: Curry._1(match.t, showMobileLotList ? "LotListButton_ariaLabel_close" : "LotListButton_ariaLabel_open")
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(Button.Button, {
                        onClick: (function (param) {
                            Curry._1(toggleMobileLotListClick, undefined);
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.display("flex"),
                              tl: {
                                hd: Css.margin2("auto", Css.px(0)),
                                tl: /* [] */0
                              }
                            }),
                        buttonStyle: "tertiary",
                        size: "regularIcon",
                        children: showMobileLotList ? React.createElement(SterlingIcons$LiveRoom.Collection.CloseRegular24.make, {
                                className: Curry._1(Css.style, {
                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                                      tl: /* [] */0
                                    })
                              }) : React.createElement(SterlingIcons$LiveRoom.Collection.TextListNumbered24.make, {
                                className: Curry._1(Css.style, {
                                      hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryNavy100_nohashtag)),
                                      tl: /* [] */0
                                    })
                              })
                      })
                }), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.margin2("auto", Css.px(4)),
                        tl: {
                          hd: Css.textAlign("center"),
                          tl: /* [] */0
                        }
                      })
                }, React.createElement(Tooltip.Tooltip, {
                      classes: {},
                      enterTouchDelay: 0,
                      leaveTouchDelay: 0,
                      title: React.createElement(HeaderSessionIndicator$LiveRoom.make, {
                            sessions: fragment.sessions,
                            sessionOnDisplay: props.sessionOnDisplay
                          }),
                      children: null
                    }, React.createElement(Header$AuctionTitle, {
                          auctionName: Belt_Option.getWithDefault(fragment.title, "")
                        }), null)), React.createElement(Header$MobileMenuDropdown, {
                  isSessionLive: props.isSessionLive,
                  date: props.date,
                  location: fragment.location,
                  setModalToShow: props.setModalToShow,
                  baseCurrency: props.baseCurrency,
                  enrollmentSessionStatus: props.enrollmentSessionStatus,
                  showMobileLotList: showMobileLotList,
                  showSelectAccount: props.showSelectAccount,
                  saleNumber: fragment.sapSaleNumber
                }));
}

var DesktopAndMobileView = {
  make: Header$DesktopAndMobileView
};

function Header$DesktopAndTabletLandscapeView(props) {
  var enrollmentSessionStatus = props.enrollmentSessionStatus;
  var setModalToShow = props.setModalToShow;
  var sessionState = props.sessionState;
  var sessionOnDisplay = props.sessionOnDisplay;
  var fragment = props.fragment;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var sessionIdOnDisplay = Belt_Option.mapWithDefault(sessionOnDisplay, 0, (function (x) {
          return x.sessionId;
        }));
  var nextSession = Belt_Array.getBy(fragment.sessions, (function (s) {
          if (s.sessionId === (sessionIdOnDisplay + 1 | 0)) {
            if (s.state.state === "Open") {
              return true;
            } else {
              return s.state.state === "PreOpen";
            }
          } else {
            return false;
          }
        }));
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.display("flex"),
                        tl: {
                          hd: Css.justifyContent("center"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.width(Css.px(24)),
                              tl: {
                                hd: Css.margin2("zero", Css.px(16)),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      })
                }, React.createElement(SvgImages$LiveRoom.SothebysLogoSmall.make, {})), React.createElement(Header$UserRegistration, {
                  enrollmentSessionStatus: enrollmentSessionStatus,
                  showIncompleteRegistrationModal: (function (param) {
                      AnalyticsManager$LiveRoom.actionNeededPendingEnrollmentViewed(fragment.sapSaleNumber, undefined, "LiveRoom", undefined, undefined, "ActionNeededToBid");
                      Curry._1(setModalToShow, (function (param) {
                              return /* ActionNeededToBid */3;
                            }));
                    })
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "auctionHeaderTitle"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        className: Curry._1(Css.style, {
                              hd: Css.margin2("auto", Css.px(4)),
                              tl: {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.justifyContent("center"),
                                  tl: /* [] */0
                                }
                              }
                            })
                      }, React.createElement(Header$AuctionTitle, {
                            auctionName: Belt_Option.getWithDefault(fragment.title, "")
                          }), React.createElement(HeaderSessionIndicator$LiveRoom.make, {
                            sessions: fragment.sessions,
                            sessionOnDisplay: sessionOnDisplay
                          }))
                }), React.createElement("div", undefined, Belt_Option.isSome(nextSession) && sessionState === "Closed" && !props.lotIsUpcomingOrLive ? React.createElement(Button.Button, {
                        onClick: (function (param) {
                            GoTo$LiveRoom.auctionDetails(Utils_Auction$LiveRoom.getAuctionUrl(fragment.slug.name, fragment.slug.year, Belt_Option.map(nextSession, (function (s) {
                                            return s.sessionId;
                                          })), undefined));
                          }),
                        className: Curry._1(Css.style, {
                              hd: Css.fontWeight({
                                    NAME: "num",
                                    VAL: 500
                                  }),
                              tl: {
                                hd: Css.width("auto"),
                                tl: {
                                  hd: Css.height(Css.px(40)),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        buttonStyle: "secondary",
                        children: Curry._1(match.t, "ViewUpcomingSession")
                      }) : null), React.createElement(Header$MobileMenuDropdown, {
                  isSessionLive: sessionState === "Open",
                  date: props.date,
                  location: fragment.location,
                  setModalToShow: setModalToShow,
                  baseCurrency: props.baseCurrency,
                  enrollmentSessionStatus: enrollmentSessionStatus,
                  showMobileLotList: props.showMobileLotList,
                  showSelectAccount: props.showSelectAccount,
                  saleNumber: fragment.sapSaleNumber
                }));
}

var DesktopAndTabletLandscapeView = {
  make: Header$DesktopAndTabletLandscapeView
};

function Header(props) {
  var showSelectAccount = props.showSelectAccount;
  var setAlternativeCurrency = props.setAlternativeCurrency;
  var showMobileLotList = props.showMobileLotList;
  var toggleMobileLotListClick = props.toggleMobileLotListClick;
  var sessionIdOnDisplay = props.sessionIdOnDisplay;
  var fragment = props.fragment;
  var toggleMobileLotListClick$1 = toggleMobileLotListClick !== undefined ? toggleMobileLotListClick : (function (param) {
        
      });
  var showMobileLotList$1 = showMobileLotList !== undefined ? showMobileLotList : false;
  var setAlternativeCurrency$1 = setAlternativeCurrency !== undefined ? setAlternativeCurrency : (function (param) {
        
      });
  var match = React.useState(function () {
        return /* NoModal */0;
      });
  var setModalToShow = match[1];
  var sessionOnDisplay = React.useMemo((function () {
          return Belt_Array.getBy(fragment.sessions, (function (x) {
                        return Caml_obj.equal(x.sessionId, sessionIdOnDisplay);
                      }));
        }), [sessionIdOnDisplay]);
  var sessionState = Belt_Option.mapWithDefault(sessionOnDisplay, "Closed", (function (x) {
          return x.state.state;
        }));
  var isSessionLive = sessionState === "Open";
  var date = Belt_Option.map(sessionOnDisplay, (function (x) {
          return x.scheduledOpeningDate;
        }));
  var auctionId = fragment.auctionId;
  var $$location = fragment.location;
  var baseCurrency = Belt_Option.getWithDefault(fragment.currency, "USD");
  var enrollmentSessionStatus = CustomerSession$LiveRoom.sessionStatusV2(props.me, fragment.enrollment.enrollmentResult);
  var tmp;
  switch (match[0]) {
    case /* NoModal */0 :
        tmp = null;
        break;
    case /* OverviewModal */1 :
        tmp = React.createElement(OverviewModal$LiveRoom.make, {
              auctionId: auctionId,
              onClose: (function (param) {
                  Curry._1(setModalToShow, (function (param) {
                          return /* NoModal */0;
                        }));
                })
            });
        break;
    case /* ConditionsOfSaleModal */2 :
        tmp = React.createElement(ConditionsOfSaleModal$LiveRoom.make, {
              auctionId: auctionId,
              onClose: (function (param) {
                  Curry._1(setModalToShow, (function (param) {
                          return /* NoModal */0;
                        }));
                })
            });
        break;
    case /* ActionNeededToBid */3 :
        tmp = React.createElement(ActionNeededPendingEnrollment$LiveRoom.make, {
              onClose: (function (param) {
                  Curry._1(setModalToShow, (function (param) {
                          return /* NoModal */0;
                        }));
                }),
              location: AuctionRoomSharedContacts$LiveRoom.getAuctionLocationType(Belt_Option.getWithDefault(Belt_Option.map($$location, (function (l) {
                              return l.name;
                            })), ""))
            });
        break;
    case /* AlternativeCurrencyModal */4 :
        tmp = React.createElement(AlternativeCurrencyModal$LiveRoom.make, {
              baseCurrency: baseCurrency,
              sapSaleNumber: fragment.sapSaleNumber,
              onClose: (function (param) {
                  Curry._1(setModalToShow, (function (param) {
                          return /* NoModal */0;
                        }));
                }),
              setAlternativeCurrency: setAlternativeCurrency$1
            });
        break;
    
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.margin4(Css.px(8), Css.px(8), Css.px(0), Css.px(8)),
                        tl: {
                          hd: Css.display("grid"),
                          tl: {
                            hd: Css.gridTemplateColumns({
                                  hd: "auto",
                                  tl: {
                                    hd: "auto",
                                    tl: {
                                      hd: {
                                        NAME: "fr",
                                        VAL: 4
                                      },
                                      tl: {
                                        hd: "auto",
                                        tl: {
                                          hd: "auto",
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }),
                            tl: {
                              hd: CommonStyles$LiveRoom.mediaV2(/* TabletPortraitAndMobile */2, {
                                    hd: Css.display("none"),
                                    tl: /* [] */0
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(Header$DesktopAndTabletLandscapeView, {
                      fragment: fragment,
                      sessionOnDisplay: sessionOnDisplay,
                      sessionState: sessionState,
                      date: date,
                      setModalToShow: setModalToShow,
                      enrollmentSessionStatus: enrollmentSessionStatus,
                      baseCurrency: baseCurrency,
                      showMobileLotList: showMobileLotList$1,
                      showSelectAccount: showSelectAccount,
                      lotIsUpcomingOrLive: props.lotIsUpcomingOrLive
                    })), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.margin2(Css.px(0), Css.px(4)),
                        tl: {
                          hd: Css.height(Css.pct(100)),
                          tl: {
                            hd: Css.display("grid"),
                            tl: {
                              hd: Css.gridTemplateColumns({
                                    hd: "auto",
                                    tl: {
                                      hd: {
                                        NAME: "fr",
                                        VAL: 4
                                      },
                                      tl: {
                                        hd: "auto",
                                        tl: /* [] */0
                                      }
                                    }
                                  }),
                              tl: {
                                hd: CommonStyles$LiveRoom.mediaV2(/* DesktopAndTabletLandscape */4, {
                                      hd: Css.display("none"),
                                      tl: /* [] */0
                                    }),
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      })
                }, React.createElement(Header$DesktopAndMobileView, {
                      fragment: fragment,
                      sessionOnDisplay: sessionOnDisplay,
                      toggleMobileLotListClick: toggleMobileLotListClick$1,
                      showMobileLotList: showMobileLotList$1,
                      isSessionLive: isSessionLive,
                      date: date,
                      setModalToShow: setModalToShow,
                      baseCurrency: baseCurrency,
                      enrollmentSessionStatus: enrollmentSessionStatus,
                      showSelectAccount: showSelectAccount
                    })), tmp);
}

var SessionStateFragment = ClientapiQueries$LiveRoom.AuctionHeader.SessionStateFragment;

var AuctionHeaderAuctionFragment = ClientapiQueries$LiveRoom.AuctionHeader.AuctionHeaderAuctionFragment;

var make = Header;

export {
  SessionStateFragment ,
  AuctionHeaderAuctionFragment ,
  LivePill ,
  AuctionTitle ,
  AuctionDate ,
  UserRegistration ,
  MobileMenuDropdown ,
  DesktopAndMobileView ,
  DesktopAndTabletLandscapeView ,
  make ,
}
/* imageMargin Not a pure module */
